module.exports = __webpack_public_path__ + "img/p3.6448ce0b.png";